import React from 'react'
import logo from 'layouts/moco/img/brand/edo.png'

const FrontLogo = (props) => {
  const { width = '25%', height = '25%' } = props
  return <img src={logo} alt='Logo Edoo' width={width} height={height} />
}

export default FrontLogo
